/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProceedingParticipantType = {
    Creditor: 'Creditor',
    LawFirm: 'LawFirm',
    DebtCollectionAgency: 'DebtCollectionAgency',
    Trustee: 'Trustee',
    InsolvencyAdministrator: 'InsolvencyAdministrator',
    Organisation: 'Organisation',
    Bank: 'Bank',
    Insurance: 'Insurance'
} as const;
export type ProceedingParticipantType = typeof ProceedingParticipantType[keyof typeof ProceedingParticipantType];


export function instanceOfProceedingParticipantType(value: any): boolean {
    for (const key in ProceedingParticipantType) {
        if (Object.prototype.hasOwnProperty.call(ProceedingParticipantType, key)) {
            if (ProceedingParticipantType[key as keyof typeof ProceedingParticipantType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProceedingParticipantTypeFromJSON(json: any): ProceedingParticipantType {
    return ProceedingParticipantTypeFromJSONTyped(json, false);
}

export function ProceedingParticipantTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProceedingParticipantType {
    return json as ProceedingParticipantType;
}

export function ProceedingParticipantTypeToJSON(value?: ProceedingParticipantType | null): any {
    return value as any;
}

export function ProceedingParticipantTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProceedingParticipantType {
    return value as ProceedingParticipantType;
}

